// extracted by mini-css-extract-plugin
module.exports = {"root":"_2D6rh","ArrowsMenuButtonSkin":"_3in03","arrowsMenuButtonSkin":"_3in03","linkElement":"_2TZ46","arrowHead":"_16G1x","arrowTail":"_2T8eQ","label":"_1x2vr"};